import type { ComponentInternalInstance, VNodeChild } from 'vue'
import { defineComponent, h, normalizeClass, render } from 'vue'

const TooltipContent = defineComponent({
  setup(_props, { slots }) {
    return () => {
      const { default: content } = slots
      return h('div', content?.())
    }
  },
})

export function renderTooltip(owner: ComponentInternalInstance | null, container: Element, content: () => VNodeChild) {
  const node = h(TooltipContent, content)
  if (owner) {
    const provides =
      'provides' in owner && typeof owner.provides === 'object' && owner.provides !== null
        ? owner.provides
        : owner.appContext.provides
    node.appContext = { ...owner.appContext, provides: Object.create(provides) }
  }
  render(node, container)
}

export function tooltipAttributes(className: unknown): Record<string, string> {
  return {
    'data-name': 'tooltip',
    class: className ? normalizeClass(className) : 'absolute m-0 p-0 border-0',
  }
}
